import { useDispatch } from "react-redux";
import { fetchSubmissionStatsAction } from "store/actions/reports";
import { toast } from "react-toastify";
import { useCurrentUser, useLogout } from "utils/hooks";
import { useCallback } from "react";

const useFetchReports = () => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const fetchAllSubmissionStats = useCallback(() => {
    const timezoneOffset = new Date().getTimezoneOffset();
    return new Promise(() => {
      fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
              query {
                getAllSubmissionsStats {
                  currentStreak
                  longestStreak
                  totalInTotal
                  streaksPerAssignment {
                    assignmentId
                    streak
                  }
                  totalByAssignment {
                    assignmentId
                    total
                  }
                  datesForCalendar {
                    date
                    count
                  }
                }
              }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-User-Timezone-Offset": timezoneOffset.toString(),
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_reports",
        },
      })
        .then(async (res) => {
          if (res.status !== 200 && res.status !== 201) {
            const error = await res.json();
            if (error.errors[0].message.includes("BRKN_6001")) {
              toast.warn(`For security purposes please log in again.`);
              logOut();
            } else {
              toast.error(`Hmm, something went wrong.`);
              throw new Error("Failed!");
            }
          }
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            toast.error(
              `Hmm, something went wrong. ${resData.errors[0].message}`
            );
          } else {
            return dispatch(
              fetchSubmissionStatsAction(resData.data.getAllSubmissionsStats)
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }, [dispatch, logOut, user?.activeOrganizationId]);

  return {
    fetchAllSubmissionStats,
  };
};

export default useFetchReports;
